import { EntityRepository, Transaction } from "../";
import { Account, Counterparty, Currency } from "../domain";


export class TransactionRepository implements EntityRepository<Transaction> {
  private _repo: EntityRepository<Transaction>;

  constructor(repo:EntityRepository<Transaction>) {
    this._repo = repo;
  }
  checkUniqueString(attribute: (obj: Transaction) => string, value: string): boolean {
    return this._repo.checkUniqueString(attribute, value);
  }

  getAll(): Transaction[] {
    return this._repo.getAll();
  }
  get(uuid: string): Transaction | undefined {
    return this._repo.get(uuid);
  }
  async put(uuid: string, value: Transaction): Promise<void> {
    return this._repo.put(uuid, value);
  }
  async putAll(values: Transaction[]) {
    return this._repo.putAll(values);
  }
  delete(uuid: string): void {
    this._repo.delete(uuid);
  }

  findByAccount(account: Account) : Transaction[] {
    return this._repo
      .getAll()
      .filter(tx => tx.entries.filter(ent => ent.account.uuid === account.uuid).length > 0);
  }

  findByCounterparty(cp: Counterparty) : Transaction[] {
    return this._repo
      .getAll()
      .filter(tx => tx.counterparty.uuid === cp.uuid);
  }

  hasTransactionWithCurrency(cur: Currency) : boolean {
    return this._repo
      .getAll()
      .findIndex(tx => tx.entries.findIndex(ent => ent.amount.currency.uuid === cur.uuid) >= 0) >= 0
  }
}